<template>
  <div class="wall overflow-auto" id="wall" v-if="dialog">
    <div v-for="(u,i) in dialog.utterances" :key="i" class="mb-3">
      <b-row v-if="u.person && u.person.personName=='Agent'">
        <b-col cols="7">
        <b-card
           >
          <b-badge variant="transparent">{{u.person.personName}}</b-badge>
          <span v-html="u.htmlFragment" v-if="u.htmlFragment"></span>
          <span v-else v-html="u.text"></span>
        </b-card>
        </b-col>
        <b-col cols="5"></b-col>
      </b-row>
      <b-row v-if="u.person && u.person.personName!='Agent'">
        <b-col cols="5"></b-col>
        <b-col cols="7">
          <b-card
             >
            <b-badge variant="transparent">{{u.person.personName}}</b-badge>
            <span v-html="u.htmlFragment" v-if="u.htmlFragment"></span>
            <span v-else v-html="u.text"></span>
          </b-card>
        </b-col>
      </b-row>
      <b-row v-if="!u.person">
        <b-col cols="5"></b-col>
        <b-col cols="7">
          <b-card
             >
            <b-badge variant="transparent">Unbekannt</b-badge>
            <span v-html="u.htmlFragment" v-if="u.htmlFragment"></span>
            <span v-else v-html="u.text"></span>
          </b-card>
        </b-col>
      </b-row>
    </div>
    <div id="siv">&nbsp;</div>
  </div>
</template>

<script>
export default {
  name: 'DialogWall',
  computed: {
    dialog () {
      return this.$store.state.dialog;
    }
  }
}
</script>

<style scoped>
  .wall {
    //height: 55vh;
  }
  .card-body {
    padding: 8px;
  }
</style>
